let menuLiSelector = document.querySelectorAll(".facets__disclosure");

menuLiSelector.forEach((item) => {
  let summaryElement = item.querySelector("summary");

  summaryElement.addEventListener("click", () => {
    menuLiSelector.forEach((other) => {
      if (other !== item && other.hasAttribute("open")) {
        other.removeAttribute("open");
        other.querySelector("summary")?.setAttribute("aria-expanded", false);
      }
    });
  });
});

// Close on outside click
document.addEventListener("click", (e) => {
  menuLiSelector.forEach((item) => {
    if (item.hasAttribute("open") && !item.contains(e.target)) {
      item.removeAttribute("open");
      item.querySelector("summary")?.setAttribute("aria-expanded", false);
    }
  });
});